export const APP_ROUTES = {
  LOGIN: '/login',
  FORBIDDEN: '/forbidden',
  DASHBOARD: '/dashboard',
  TICKETS: {
    ROOT: '/tickets',
    NOUVEAU: '/tickets/nouveau',
    PARTAGES: '/tickets/partages',
    RECHERCHE: '/tickets/recherche',
    DETAIL: (id: string) => `/tickets/${id}`,
  },
  CLIENTS: {
    ROOT: '/clients',
    NOUVEAU: '/clients/nouveau',
    IDENTIFIER: '/clients/identifier',
    DETAIL: (id: string) => `/clients/${id}`,
    MODIFIER: (id: string) => `/clients/${id}/modifier`,
  },
  VENTE_CROISEE: '/vente-croisee',
  SATURATION: '/saturation',
  LEADS: {
    ROOT: '/leads',
    LISTE: '/leads/liste',
    NOUVEAU: '/leads/nouveau',
    DETAIL: (id: string) => `/leads/${id}`,
  },
  MESSAGERIE: '/messagerie',
  TELEPHONIE: {
    APPELS: '/telephonie/appels',
  },
  ADMIN: {
    ROOT: '/admin',
    FILIALES: '/admin/filiales',
    CATEGORIES: '/admin/categories-motifs',
    STATUTS: '/admin/statuts',
    SERVICES_BO: '/admin/services-bo',
    USERS: '/admin/utilisateurs',
    HABILITATIONS: '/admin/habilitations',
    DELAIS: '/admin/delais',
    INTEGRATION_EXTERNE: '/admin/integration-externe',
    INTEGRATION_EXTERNE_TICKETS: '/admin/integration-externe/tickets',
  },
  REPORTING: {
    ROOT: '/reporting',
    DELAIS: '/reporting/delais',
    AGENTS: '/reporting/agents',
    AGENTS_GLOBALE: '/reporting/agents/vue-globale',
    SATISFACTION: '/reporting/satisfaction',
  },
} as const;
